module.exports = __webpack_public_path__ + "img/icon-train.916c10c8.svg";